<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="home-1">
      <div class="engine">
        <div>Explore Your Horizon in the Digital World!</div>
        <p>Welcome to Horizon Creation, your one-stop solution for SEO optimization and advertising promotion. We are dedicated to unleashing the infinite possibilities of your business in the digital realm. Whether you're looking to boost your website rankings, increase traffic, or enhance brand exposure, we provide tailored solutions to meet your needs. Let's collaborate and create a brilliant future together!</p>
        <!-- <div class="touch-btn">Get in Touch</div> -->
      </div>
    </div>

    <div class="home-2">
      <div class="title">Unlocking Your Digital <br> Potential with Our Key Offerings</div>
      <img src="../assets/home_2.png" class="sbtitle">
      <div class="home-box">
        <div class="grow-box item-1">
          <div class="">SEO Optimization</div>
          <p>Elevate your website's visibility and attract targeted traffic through our expert SEO optimization services.</p>
        </div>
        <div class="grow-box item-2">
          <div class="">Tailored Advertising Solutions</div>
          <p>Expand your reach and enhance brand recognition with our personalized advertising strategies crafted for your success.</p>
        </div>
        <div class="grow-box item-3">
          <div class="">Strategic Content Marketing Approaches</div>
          <p>Captivate and retain your audience with compelling content strategies designed to foster enduring brand loyalty.</p>
        </div>
      </div>
    </div>

    <div class="home-3">
      <div class="title">Reasons to Partner <br> with Us</div>
      <img src="../assets/home_2.png" class="sbtitle">
      <div class="list-box">
        <div class="item-us">
          <img src="../assets/home_7.png" alt="">
          <div>Innovative Solutions Tailored to You</div>
        </div>
        <div class="item-us">
          <img src="../assets/home_8.png" alt="">
          <div>Proven Expertise Driving Results</div>
        </div>
        <div class="item-us">
          <img src="../assets/home_9.png" alt="">
          <div>Dedicated Support Every Step of the Way</div>
        </div>
        <div class="item-us">
          <img src="../assets/home_10.png" alt="">
          <div>Commitment to Continuous Improvement</div>
        </div>
      </div>
    </div>

    <div class="home-4">
      <div class="title">How We Drive Success <br> for Your Business</div>
      <img src="../assets/home_2.png" class="sbtitle">
      <div class="img-box">
        <img src="../assets/home_11.png" alt="">
        <div class="img-text-1">
          <div class="img-text">Empowering Growth Through Data</div>
          <div class="slid-box">
            <div class="slid-box-1">
              <img src="../assets/icon-1.png" alt="">
              <p>Increase in Website Traffic</p>
            </div>
            <p>150%</p>
          </div>
          <div class="slid-problom-box">
            <div class="lid-problom" style="width: 100%;"></div>
          </div>
          <div class="slid-box">
            <div class="slid-box-1">
              <img src="../assets/icon-1.png" alt="">
              <p>Conversion Rate Improvement</p>
            </div>
            <p>75%</p>
          </div>
          <div class="slid-problom-box">
            <div class="lid-problom" style="width: 75%;"></div>
          </div>
        </div>
      </div>
      <div class="img-box">
        <div class="img-text-1">
          <div class="img-text">Personalized Strategies for Your Success？</div>
          <div class="slid-box">
            <p class="slid-box-text">At Horizon Creation, we don't just offer cookie-cutter solutions. Our team of experts crafts personalized strategies tailored to your unique business needs and goals. With our dedicated support and collaborative approach, we're committed to driving your success in the digital landscape. </p>
          </div>

        </div>

        <img src="../assets/home_11.png" alt="">
      </div>
    </div>
    <footerBox :step="1"></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.home-1 {
  background-image: url(../assets/home_1.png);
  background-size: 100% 100%;
  height: 800px;

  .engine {
    width: 900px;
    padding-top: 222px;
    margin-left: 360px;

    div {
      font-weight: 600;
      font-size: 75px;
      color: #040F1C;
    }

    p {
      font-weight: 400;
      font-size: 20px;
      color: rgba(51, 51, 51, 0.8);
      margin-top: 48px;
    }

    .touch-btn {
      width: 194px;
      height: 60px;
      background: #59BA41;
      font-weight: 400;
      font-size: 24px;
      color: #FFFFFF;
      text-align: center;
      line-height: 60px;
      margin-top: 40px;
    }
  }
}

.title {
  font-weight: 600;
  font-size: 58px;
  color: #333333;
}

.sbtitle {
  width: 305px;
  margin: auto;
  margin-top: 20px;
}

.home-2 {
  padding: 120px 360px;
  text-align: center;

  .home-box {
    margin-top: 80px;
    padding: 0px 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .grow-box {
      width: 300px;
      height: 437px;
      padding: 40px;
      background-size: 100% 100%;
      text-align: left;

      div {
        font-weight: bold;
        font-size: 26px;
        color: #333333;
      }

      p {
        font-weight: 400;
        font-size: 20px;
        color: rgba(51, 51, 51, 0.8);
        margin-top: 19px;
      }
    }

    .item-1 {
      background-image: url(../assets/home_3.png);
    }

    .item-2 {
      background-image: url(../assets/home_4.png);
    }

    .item-3 {
      background-image: url(../assets/home_5.png);
    }
  }
}

.home-3 {
  height: 717px;
  background: url(../assets/home_6.png);
  background-size: 100% 100%;
  padding: 80px 400px;
  text-align: center;

  .list-box {
    margin-top: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    .item-us {
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 510px;
      height: 138px;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      text-align: left;
      margin-bottom: 40px;

      img {
        width: 110px;
        margin-right: 38px;
      }

      div {
        font-weight: 400;
        font-size: 32px;
        color: #333333;
      }
    }
  }
}

.home-4 {
  padding: 120px 360px;
  text-align: center;

  .img-box {
    margin-top: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 486px;
    }

    .img-text-1 {
      text-align: left;
      width: 750px;

      .img-text {
        font-weight: bold;
        font-size: 52px;
        color: #333333;
      }

      .slid-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 68px;
        width: 644px;

        .slid-box-text {
          font-weight: 400;
          font-size: 20px;
          color: rgba(51, 51, 51, 0.8);
        }

        .slid-box-1 {
          display: flex;
          align-items: center;

          img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }

          p {
            font-weight: 400;
            font-size: 18px;
            color: #777777;
          }
        }

        p {
          font-weight: bold;
          font-size: 18px;
          color: #263959;
        }
      }

      .slid-problom-box {
        width: 644px;
        height: 16px;
        background: #F3F2F8;
        border-radius: 80px 80px 80px 80px;
        margin-top: 20px;

        .lid-problom {
          height: 16px;
          background: #6EC856;
          border-radius: 80px 80px 80px 80px;
        }
      }
    }
  }
}
</style>
